"use client";

import { StatCard, StatGrid } from "@/components/tool-kit/primitives";
import { CARD, WIDGET_H2, WIDGET_H3 } from "@/components/tool-kit/styles";
import type { IV_DRIP_RATE_CALCULATOR_STRINGS } from "@/components/tools/iv-drip-rate-calculator";
import { WorkingLine } from "@/components/tools/stats-clinical/data-grid";
import type {
  IvMode,
  IvOutput,
} from "@/components/tools/stats-clinical/iv-compute";

/*
 * The result cards and the worked steps, with the unit-cancellation notes, for the IV drip
 * calculator. Strings are the widget's own.
 */

type Strings = typeof IV_DRIP_RATE_CALCULATOR_STRINGS;

export function IvResults({
  output,
  mode,
  strings,
}: {
  output: IvOutput;
  mode: IvMode;
  strings: Strings;
}) {
  return (
    <div aria-live="polite" className="space-y-4">
      <h2 className={WIDGET_H2}>{strings.results}</h2>
      <StatGrid>
        {output.cards.map(([label, value], index) => (
          <StatCard
            emphasis={index === output.cards.length - 1}
            key={label}
            label={label}
            value={value}
          />
        ))}
      </StatGrid>
      <div className={`${CARD} space-y-2`}>
        <h3 className={WIDGET_H3}>{strings.workingHeading}</h3>
        {output.steps.map((step) => (
          <WorkingLine key={step}>{step}</WorkingLine>
        ))}
        <p className="text-muted-foreground text-sm">
          {mode === "duration" ? strings.stepTimeUnits : strings.stepUnits}
        </p>
        {output.micro ? (
          <p className="text-muted-foreground text-sm">{strings.stepMicro}</p>
        ) : null}
        {mode === "duration" ? null : (
          <p className="text-muted-foreground text-sm">
            {strings.roundingNote}
          </p>
        )}
      </div>
    </div>
  );
}
